import { useQuery } from '@zg-rentals/react-query5';
import {
  RentalManagerGuestSupportWebApiHandler_getHelpArticles,
  RentalManagerGuestSupportWebApiHandler_getHelpTopics,
  RentalManagerUserSupportWebApiHandler_getHelpArticles,
  RentalManagerUserSupportWebApiHandler_getHelpTopics,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  GuestSupportGetHelpTopicsResponseWebDto,
  RentalManagerSupportHelpArticlesResponseDto,
  RentalManagerSupportHelpCategory,
  RentalManagerSupportHelpTopic,
} from '@zg-rentals/ts-rental-manager-api-client';

export const useGetHelpArticles = ({ category = '', topic = '', isLoggedIn = false }, queryOptions = {}) => {
  return useQuery<RentalManagerSupportHelpArticlesResponseDto, Error>({
    queryKey: ['getHelpArticles', category, topic],
    queryFn: async () => {
      //  omit empty params — an empty string can't decode to the non-null category/topic
      //  enum on the BE and returns a 500. Omitted params are handled fine (returns defaults).
      const getParams = {
        ...(category ? { category: category as RentalManagerSupportHelpCategory } : {}),
        ...(topic ? { topic: topic as RentalManagerSupportHelpTopic } : {}),
      };
      return isLoggedIn
        ? RentalManagerUserSupportWebApiHandler_getHelpArticles(getParams)
        : RentalManagerGuestSupportWebApiHandler_getHelpArticles(getParams);
    },
    meta: {
      tags: ['helpArticles'],
      context: { api: 'support', details: 'getHelpArticles' },
    },
    ...queryOptions,
    staleTime: 10 * 60 * 1000,
  });
};

export const useGetHelpTopics = ({ isLoggedIn = false }, queryOptions = {}) => {
  return useQuery<GuestSupportGetHelpTopicsResponseWebDto, Error>({
    queryKey: ['getHelpTopics'],
    queryFn: async () => {
      return isLoggedIn
        ? RentalManagerUserSupportWebApiHandler_getHelpTopics()
        : RentalManagerGuestSupportWebApiHandler_getHelpTopics();
    },
    meta: {
      tags: ['helpTopics'],
      context: { api: 'support', details: 'getHelpTopics' },
    },
    ...queryOptions,
    staleTime: 10 * 60 * 1000,
  });
};
